import { useParams } from 'react-router-dom';
import PrintDDP from 'components/widgets/PrintProjectDetails/PrintDDP';
import PrintPDP from 'components/widgets/PrintProjectDetails/PrintPDP';
import { isDocumentViewQuery } from 'state/queryParams';

const ProjectDetailsPage = () => {
  const { id: projectSlug } = useParams();
  const [isDocumentView] = isDocumentViewQuery();

  if (isDocumentView) {
    return <PrintDDP documentId={projectSlug as string} />;
  }

  return <PrintPDP projectSlug={projectSlug as string} />;
};

export default ProjectDetailsPage;
